import { io } from "socket.io-client";
import array_move from "../../utils/arrayMoveIndex";
import { apiSlice } from "../api/apiSlice";
import { messagesApi } from "../messages/messagesApi";

export const conversationsApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getConversations: builder.query({
            query: (email) =>
                `/conversations?participants_like=${email}&_sort=timestamp&_order=desc&_page=1&_limit=${process.env.REACT_APP_CONVERSATIONS_PER_PAGE}`,

            transformResponse: (response, meta) => {
                const totalCount =
                    meta?.response?.headers?.get("X-Total-Count");

                return {
                    data: response,
                    totalCount,
                };
            },

            async onCacheEntryAdded(
                arg,
                { cacheDataLoaded, cacheEntryRemoved, updateCachedData }
            ) {
                //initialize socket
                const socket = io(
                    "https://chat-app-server-by-saurav.herokuapp.com",
                    {
                        reconnectionDelay: 1000,
                        reconnection: true,
                        reconnectionAttempts: 10,
                        transports: ["websocket"],
                        agent: false,
                        upgrade: false,
                        rejectUnauthorized: false,
                    }
                );

                try {
                    await cacheDataLoaded;

                    socket.on("conversation", (data) => {
                        if (!data?.data?.participants?.includes(arg)) return;

                        updateCachedData((draft) => {
                            const conversation = draft?.data?.find(
                                (c) => c.id == data?.data?.id
                            );

                            const index = draft?.data.indexOf(conversation);

                            if (conversation?.id) {
                                conversation.message = data?.data?.message;
                                conversation.timestamp = data?.data?.timestamp;

                                // // changing the index to the top
                                array_move(draft?.data, index, 0);
                                // draft?.data.sort(
                                //     (a, b) => a.timestamp - b.timestamp
                                // );
                            } else {
                                draft?.data.unshift(data?.data);
                                // draft?.data.sort(
                                //     (a, b) => a.timestamp - b.timestamp
                                // );
                            }
                        });
                    });
                } catch (error) {}

                await cacheEntryRemoved;
                socket.close();
            },
        }),

        getMoreConversations: builder.query({
            query: ({ email, page }) =>
                `/conversations?participants_like=${email}&_sort=timestamp&_order=desc&_page=${page}&_limit=${process.env.REACT_APP_CONVERSATIONS_PER_PAGE}`,

            async onQueryStarted({ email }, { queryFulfilled, dispatch }) {
                try {
                    const { data } = (await queryFulfilled) || {};

                    if (data?.length > 0) {
                        dispatch(
                            apiSlice.util.updateQueryData(
                                "getConversations",
                                email,
                                (draft) => {
                                    return {
                                        data: [...draft.data, ...data],
                                        totalCount: Number(draft.totalCount),
                                    };
                                }
                            )
                        );
                    }
                } catch (error) {}
            },
        }),

        getConversation: builder.query({
            query: ({ userEmail, participantEmail }) =>
                `/conversations?participants_like=${userEmail}-${participantEmail}&&participants_like=${participantEmail}-${userEmail}`,
        }),

        addConversations: builder.mutation({
            query: ({ sender, data }) => ({
                url: "/conversations",
                method: "POST",
                body: data,
            }),

            async onQueryStarted(
                { sender: senderEmail },
                { queryFulfilled, dispatch }
            ) {
                try {
                    const { data } = (await queryFulfilled) || {};
                    const { id, users, message, timestamp } = data || {};

                    const senderUser = users?.find(
                        (user) => user.email === senderEmail
                    );
                    const receiverUser = users?.find(
                        (user) => user.email !== senderEmail
                    );

                    if (id) {
                        // //pessimistic cache update for add conversation
                        // dispatch(
                        //     apiSlice.util.updateQueryData(
                        //         "getConversations",
                        //         senderEmail,
                        //         (draft) => {
                        //             draft?.data.unshift(data);
                        //         }
                        //     )
                        // );

                        // silent entry to the messages table
                        dispatch(
                            messagesApi.endpoints.addMessage.initiate({
                                conversationId: id,
                                sender: senderUser,
                                receiver: receiverUser,
                                message,
                                timestamp,
                            })
                        );
                    }
                } catch (error) {}
            },
        }),

        editConversations: builder.mutation({
            query: ({ sender, id, data }) => ({
                url: `/conversations/${id}`,
                method: "PATCH",
                body: data,
            }),

            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                //optimistic cache update for edit conversation
                // const patchResult = dispatch(
                //     apiSlice.util.updateQueryData(
                //         "getConversations",
                //         arg.sender,
                //         async (draft) => {
                //             // here double == because draft stores only strings
                //             const draftConversation = draft?.data?.find(
                //                 (c) => c.id == arg.id
                //             );
                //             draftConversation.message = arg.data.message;
                //             draftConversation.timestamp = arg.data.timestamp;
                //         }
                //     )
                // );

                try {
                    const { data } = (await queryFulfilled) || {};
                    const { id, users, message, timestamp } = data || {};

                    const senderUser = users?.find(
                        (user) => user.email === arg?.sender
                    );
                    const receiverUser = users?.find(
                        (user) => user.email !== arg?.sender
                    );

                    if (id) {
                        // silent entry to the messages table
                        dispatch(
                            messagesApi.endpoints.addMessage.initiate({
                                conversationId: id,
                                sender: senderUser,
                                receiver: receiverUser,
                                message,
                                timestamp,
                            })
                        );

                        // const res = await dispatch(
                        //     messagesApi.endpoints.addMessage.initiate({
                        //         conversationId: id,
                        //         sender: senderUser,
                        //         receiver: receiverUser,
                        //         message,
                        //         timestamp,
                        //     })
                        // ).unwrap();

                        // //pessimistic cache update for edit conversation
                        // dispatch(
                        //     apiSlice.util.updateQueryData(
                        //         "getMessages",
                        //         res?.conversationId.toString(),
                        //         (draft) => {
                        //             draft.push(res);
                        //         }
                        //     )
                        // );
                    }
                } catch (error) {
                    // patchResult.undo();
                }
            },
        }),
    }),
});

export const {
    useGetConversationsQuery,
    useGetConversationQuery,
    useAddConversationsMutation,
    useEditConversationsMutation,
} = conversationsApi;
